import { create } from 'zustand';
import { isTeamsSsoReloading } from '@/utils/sso-session-guard';

interface LoaderStore {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

export const useLoaderStore = create<LoaderStore>((set) => ({
  isLoading: isTeamsSsoReloading(),
  setIsLoading: (loading) => set({ isLoading: loading }),
}));
